var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"cursor-changer",class:{ 'is-mask': _vm.isMask }})}
var staticRenderFns = []

export { render, staticRenderFns }